// extracted by mini-css-extract-plugin
module.exports = {"text":"TextOverflowTooltip_text__2Uw9r"};